export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21.727 27.62l-5.334-5.334 1.894-1.88 3.053 3.054V5.34h2.667v18.12l3.053-3.053 1.88 1.88-5.333 5.333c-.52.52-1.36.52-1.88 0zM4.94 11.606l-1.88-1.88 5.333-5.333c.52-.52 1.36-.52 1.88 0l5.334 5.334-1.88 1.88-3.054-3.054v18.12H8.007V8.553L4.94 11.606z\" fill=\"#000\" fill-opacity=\".15\"/>",
  "attrs": {
    "width": "32",
    "height": "32",
    "viewBox": "0 0 32 32",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};